export const appSettingsInternalUserGroupsTestUserAppData = "/internal_user_groups/test_user_app_data";
